import { render, staticRenderFns } from "./deviceWorkerDeal.vue?vue&type=template&id=56f04990&scoped=true&"
import script from "./deviceWorkerDeal.vue?vue&type=script&lang=js&"
export * from "./deviceWorkerDeal.vue?vue&type=script&lang=js&"
import style0 from "./deviceWorkerDeal.vue?vue&type=style&index=0&id=56f04990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f04990",
  null
  
)

export default component.exports